import makeApiCall from "../master/axiosIndex";

const importApis = {
  // List all imports with filters
  listImports: (params: any) =>
    makeApiCall({
      url: "/bulkUpload/bulkUploadRequestedListWithPagination",
      method: "get",
      params,
    }),

  // Get import by ID
  getImportById: (importId: string) =>
    makeApiCall({
      url: `/bulk-import/id/${importId}`,
      method: "get",
    }),

  // Delete import
  deleteImport: (importId: string) =>
    makeApiCall({
      url: `/excel-upload/deleteExcelCreationById`,
      method: "delete",
      params: { id: importId, appType: "WOM" },
    }),

  // Download import file
  downloadImportFile: (importId: string) =>
    makeApiCall({
      url: `/bulk-import/download/${importId}`,
      method: "get",
    }),

  // Upload and validate RA Bill bulk file
  uploadRABillBulk: (formData: FormData) =>
    makeApiCall({
      url: "/ra-bill/bulk-upload",
      method: "post",
      data: formData,
      // headers: {
      //   "Content-Type": "multipart/form-data",
      // },
    }),
  uploadDefaultData: (reportType: any, flowType?: string) =>
    makeApiCall({
      url: "/work-order/excel-upload-master-data",
      method: "post",
      data: {
        reportType: reportType,
        ...(flowType && { flowType: flowType }),
      },
    }),

  // Upload and validate Payment bulk file
  uploadPaymentBulk: (formData: FormData) =>
    makeApiCall({
      url: "/ra-bill/payment/bulk-upload",
      method: "post",
      data: formData,
      // headers: {
      //   "Content-Type": "multipart/form-data",
      // },
    }),

  // Get errors for a specific import
  getImportErrors: (importId: string) =>
    makeApiCall({
      url: `/bulk-import/errors/${importId}`,
      method: "get",
    }),

  // Retry failed import
  retryImport: (importId: string) =>
    makeApiCall({
      url: `/bulk-import/retry/${importId}`,
      method: "post",
    }),

  // Get import status (for polling)
  getImportStatus: (importId: string) =>
    makeApiCall({
      url: `/bulk-import/status/${importId}`,
      method: "get",
    }),

  // Get converted JSON list with pagination
  getConvertedJsonList: (params: {
    reportId: number;
    pageNo: number;
    size: number;
  }) =>
    makeApiCall({
      url: "/excel-upload/fetchReportById",
      method: "get",
      params,
    }),

  // Process excel creation by report ID
  processExcelCreation: (reportId: number) =>
    makeApiCall({
      url: "/excel-upload/processExcelCreationById",
      method: "patch",
      params: { id: reportId },
    }),
};

export default importApis;
